import { useId, useLabels } from "@react-aria/utils";
/**
 * Provides the accessibility implementation for labels and their associated elements.
 * Labels provide context for user inputs.
 * @param props - The props for labels and fields.
 */

export function useLabel(props) {
  var id = props.id,
      label = props.label,
      ariaLabelledby = props['aria-labelledby'],
      ariaLabel = props['aria-label'],
      _props$labelElementTy = props.labelElementType,
      labelElementType = _props$labelElementTy === void 0 ? 'label' : _props$labelElementTy;
  id = useId(id);
  var labelId = useId();
  var labelProps = {};

  if (label) {
    ariaLabelledby = ariaLabelledby ? ariaLabelledby + " " + labelId : labelId;
    labelProps = {
      id: labelId,
      htmlFor: labelElementType === 'label' ? id : undefined
    };
  } else if (!ariaLabelledby && !ariaLabel) {
    console.warn('If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility');
  }

  var fieldProps = useLabels({
    id: id,
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledby
  });
  return {
    labelProps: labelProps,
    fieldProps: fieldProps
  };
}